<template>
  <div class="space-y-2">
    <p
      v-if="showLabel"
      class="text-xs font-semibold tracking-wide text-gray-400 uppercase">
      {{ label || 'Send to Friend' }}
    </p>
    <button
      class="flex gap-2 justify-center items-center py-3 px-4 w-full text-sm font-medium text-white bg-gray-800 rounded-lg transition-colors hover:bg-gray-700"
      @click="handleSendToFriend">
      <fa-icon icon="paper-plane" />
      <span>{{ buttonText || 'Send this review' }}</span>
      <fa-icon icon="chevron-right" class="text-gray-500" />
    </button>
  </div>
</template>

<script setup>
import { useStoreModals } from '@/stores/storeModals'

const props = defineProps({
  review: {
    type: Object,
    default: null
  },
  title: {
    type: Object,
    default: null
  },
  showLabel: {
    type: Boolean,
    default: true
  },
  label: {
    type: String,
    default: null
  },
  buttonText: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['send'])

const storeModals = useStoreModals()

const handleSendToFriend = () => {
  if (props.review || props.title) {
    storeModals.openChildModal({
      type: 'SendToUser',
      props: {
        review: props.review,
        title: props.title
      }
    })
  }
  emit('send')
}
</script>
